// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__rlLYB"};